function log(value) {
  if (CityGrows.Server.env !== 'production') {
    console.log(value);
  }
}

export default {
  log,
};
